import appStorage from 'helpers/AppStorage';

export default class Authorize {
    api = null;
    usedAdapter = null;
    authorized = null;
    userName = null;
    userEmail = null;
    userId = null;

    constructor(apiAdapter) {
        if (!apiAdapter) {
            throw Error('NO SUPPLIED APIADAPTER');
        }
        this.api = apiAdapter;
    }

    getSessionContext() {
        if (this.userId && this.api === this.usedAdapter) {
            return Promise.resolve(this.userId);
        }
        return this.api
            .run('getSessionContext')
            .then((data) => {
                if (data.userType === 'R') {
                    this.authorized = true;
                }

                if (data.userName) {
                    this.userName = data.userName;
                }

                if (data.emailAddress) {
                    this.userEmail = data.emailAddress;
                }

                this.userId = data.userId;
                if (this.userId.toString() !== appStorage('userId')) {
                    // User has changed, we should remove everything we saved about him.
                    appStorage('selectedList', null);
                    appStorage('selectedStore', null);
                    appStorage('shoppingListView', null);
                    appStorage('partsCollected', null);
                    appStorage('excludeVAT', null);
                    appStorage('cookieInfoShown', null);
                    appStorage('userId', this.userId);
                }
                // Keep access token in sync with appStorage
                if (data.accessToken && data.accessToken !== appStorage('accessToken')) {
                    appStorage('accessToken', data.accessToken);
                }

                this.usedAdapter = this.api;
                return this.userId;
            })
            .catch(error => {
                console.error(error); // eslint-disable-line no-console
                throw new Error(error);
            });
    }

    logUser(username, password) {
        const headers = new Headers({
            'Accept': 'application/vnd.ikea.iows+json;version=1.0',
            'Contract': window.Checkout.settings.authentication.contract,
            'Consumer': window.Checkout.settings.authentication.consumer,
        });

        const init = {
            method: 'POST',
            headers: headers,
            mode: 'cors',
            credentials: 'include',
            body: 'password=' + password,
        };

        const request = new Request(window.Checkout.settings.authentication.endpoint + '/retail/iows/' + window.Checkout.settings.locale_url + '/customer/irw/' + username, init);

        return fetch(request)
            .then((response) => {
                // Simulate wrong credentials in case of 404 which means that the user had not been understood.
                if (response.status === 404) {
                    return Promise.resolve({ AuthenticationResult: { AuthReason: { ReasonCode: { $: 3001 } } } });
                }
                if (!response.ok) {
                    throw new Error(response.status);
                }

                return response.json();
            })
            .then((data) => {
                if (data.AuthenticationResult.AuthReason.ReasonCode.$ === 1001) {
                    appStorage('userId', null);
                    this.userId = null;
                    return this.getSessionContext();
                }

                return data.AuthenticationResult.AuthReason.ReasonCode.$;
            })
            .catch((error) => {
                throw new Error(error);
            });
    }

    isLoggedIn() {
        return this.authorized;
    }

    // Getters
    getUsername() {
        if (this.userName) {
            return this.userName;
        }

        return false;
    }

    getEmail() {
        if (this.userEmail) {
            return this.userEmail;
        }

        return false;
    }
}
